import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const MenuContainer = styled.div`
    width: 220px;
    height: 100vh;
    position: fixed;
    background: radial-gradient(circle at 48% 3%, #fb721b, #fd3260);
    top: 0;
`;

export const MenuContentWrapper = styled.div`
    width: 100%;
`;

export const MenuHeader = styled.div`
    width: 100%;
    padding: 16px;
    margin-bottom: 5px;
`;

export const MenuBottom = styled.div`
    position: absolute;
    bottom: 15px;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const MenuButton = styled(NavLink)`
    width: 210px;
    height: 34px;
    font-size: 14px;
    color: #fff;
    font-weight: 200;

    &:focus {
        text-decoration: none;
        font-weight: 500;
    }

    &.active {
        & > div {
            background-color: #fa956c;
            font-weight: 500;
        }
    }

    &:hover {
        & > div {
            background-color: #fa956c;
            font-weight: 500;
            transition: all 0.25s;
        }
    }

    & > div {
        width: 210px;
        height: 37px;
        display: flex;
        align-items: center;
        padding-left: 22px;
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        transition: background-color 0.5s;
        margin: 6px 0;
    }
`;

export const SeparatorWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 12px 0;
`;

export const Separator = styled.div`
    width: 190px;
    height: 2px;
    opacity: 0.2;
    border-radius: 2.5px;
    background-color: #ffffff;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/AdminSideMenu/style.js